// BottomSheet — mobile bottom drawer built on MUI Drawer (anchor=bottom) with
// a drag handle and rounded top. Used for mobile nav, filters and alert
// overflow. For the full swipe-to-dismiss prototype behavior, swap to MUI
// SwipeableDrawer later; this covers tap-scrim and Esc close out of the box.
import PropTypes from 'prop-types';
import MuiDrawer from '@mui/material/Drawer';
import { cx } from '../../../utils/cx';
import './bottom-sheet.css';

export function BottomSheet({ open, onClose, title, children, flush = false }) {
  return (
    <MuiDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: { className: cx('bottom-sheet__paper', flush && 'bottom-sheet__paper--flush') },
        backdrop: { sx: { backgroundColor: 'rgba(10,12,20,0.4)' } },
      }}
    >
      <div className="bottom-sheet__handle" aria-hidden="true" />
      {title && <h2 className="bottom-sheet__title">{title}</h2>}
      <div className={cx('bottom-sheet__body', flush && 'bottom-sheet__body--flush')}>
        {children}
      </div>
    </MuiDrawer>
  );
}

BottomSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  /** Full-bleed mode: drops paper padding and makes the body a bounded flex
   *  column scroll region, so the caller can pin its own header/footer. */
  flush: PropTypes.bool,
};

export default BottomSheet;
